import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { Card } from 'antd';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import {app} from '../../config';
import useFetchStates from '../../hooks/fetchStates';
import useFetchCountries from '../../hooks/fetchCountries';

const { TextArea } = Input;
const AddCountry = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [countryObj, setCountryObj] = useState({
    causeCategory: '',
    isActive: ''
  });
  let user = JSON.parse(localStorage.getItem('user'));
  
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // console.log(causeCat[0].cause_category);
const s=useFetchStates();
const states=s.response?s.response.data:[];
const c=useFetchCountries();
const countries=c.response?c.response.data:[];
console.log(countries);
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/country/add`, uploadObj);
      console.log(res);
      window.alert(res.data.message);
      if (res.data.statusCode===200) navigate('/country/view');
    } catch (err) {
      console.log("Error");
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  }
  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setCountryObj({
      name: values.name ? values.name : '',
      // stateId: values.stateId ? values.stateId : '',
      currencySymbol:values.currencySymbol? values.currencySymbol : '',
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
  };
  console.log(countryObj);
  if(Object.keys(countryObj).length>0)uploadData(countryObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const renderList = []; //For testing purposes
  return (
    <div className='col-lg-9 mt-4 tbl p-4'>
    <div className='fs-3 text-center mb-4 fw-bold'>{t('Add Country')}</div>
    <Form
            name='basic'
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              remember: true,
              // ['id']: 1,
              // ['causename']: 'Hammad',
              // ['causeCategory']:'test', 
              // ['isActive']: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Form.Item  
              colon={false}
              label='Country Name'
              name='name'
              rules={[
                {
                  required: true,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item  
              colon={false}
              label='Currency'
              name='currencySymbol'

              rules={[
                {
                  required: true,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label='Active' valuePropName='checked'  colon={false} name='isActive'>
              <Switch />
            </Form.Item>
            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
              colon={false}
            >
              <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Submit
              </button>
            </Form.Item>
          </Form>
    </div>
    // </div>
  );
};

export default AddCountry;
